import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle2, Users, Building2, Briefcase } from 'lucide-react';
import { motion } from 'framer-motion';
import { AuthPageShell } from '../../Login/AuthPageShell';
import loginStyles from '../../Login/Login.module.css';

const businessSteps = [
  { title: 'Company info', icon: Briefcase, path: '/kyb' },
  { title: 'Verify business', icon: Building2, path: '/kyb/verify' },
  { title: 'Add stakeholders', icon: Users, path: '/kyb/stakeholders' },
];

export default function BusinessOnboarding() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentStep = businessSteps.findIndex((step) => {
    if (step.path === '/kyb') {
      return location.pathname === '/kyb';
    }
    return location.pathname.startsWith(step.path);
  });

  return (
    <AuthPageShell variant='center'>
      <div className='mx-auto flex w-full min-w-0 max-w-[720px] justify-center px-0 sm:px-2'>
        <motion.main
          className={`${loginStyles.main} ${loginStyles.mainKyb} max-h-[90vh] overflow-y-auto`}
          initial={false}
        >
          <div>
            <div className='flex items-center justify-center mb-10 sm:mb-12 flex-wrap gap-y-4'>
              {businessSteps.map((step, index) => {
                const Icon = step.icon;
                const isCompleted = index < currentStep;
                const isCurrent = index === currentStep;

                return (
                  <div key={step.path} className='flex items-center'>
                    <div
                      className='flex flex-col items-center cursor-pointer'
                      onClick={() => navigate(step.path)}
                    >
                      <div
                        className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                          isCompleted
                            ? 'bg-[#00E962]'
                            : isCurrent
                              ? 'bg-[#0055FF]'
                              : 'bg-white/[0.08] border border-white/[0.1]'
                        }`}
                      >
                        {isCompleted ? (
                          <CheckCircle2 className='w-6 h-6 text-white' />
                        ) : (
                          <Icon
                            className={`w-6 h-6 ${isCurrent ? 'text-white' : 'text-white/35'}`}
                          />
                        )}
                      </div>
                      <span
                        className={`mt-2 text-sm font-medium ${
                          isCurrent ? 'text-white' : 'text-white/45'
                        }`}
                      >
                        {step.title}
                      </span>
                    </div>
                    {index < businessSteps.length - 1 && (
                      <div
                        className={`w-12 sm:w-20 h-0.5 mx-2 sm:mx-3 ${
                          isCompleted ? 'bg-[#00E962]' : 'bg-white/[0.12]'
                        }`}
                      />
                    )}
                  </div>
                );
              })}
            </div>

            <Outlet />
          </div>
        </motion.main>
      </div>
    </AuthPageShell>
  );
}
